import React from 'react';

export function Sweden(props) {
  return (
    <svg width="513" height="342" viewBox="0 0 513 342" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="513" height="342" fill="#006AA7"/>
      <rect x="0" y="133" width="513" height="76" fill="#FECC02"/>
      <rect x="157" y="0" width="76" height="342" fill="#FECC02"/>
    </svg>
  );
}
